<template>
  <div id="navbar" :style="barStyle" >
    <transition name="fade">
      <nav>
        <a @click="infoVisible=true" class="menu-item"><span style="float: left; white-space:nowrap;">The Evolution of&#160;</span> <span style="float: left; white-space:nowrap;">European Motorways 1920–2020</span></a>
        <!--<button class="menu" href="#menu"></button>-->
      </nav>
    </transition>
    <transition name="fade">
      <div @click="infoVisible=false" class="info" v-if="infoVisible">
        <Splash ></Splash>
        <a class="quit-button" @click.stop.prevent="infoVisible=false;"><img src="@/assets/icons/quit.svg" /></a>
      </div>
    </transition>

    <template v-if="!factsPanelVisible && !infoVisible">
      <a class="mobile" target="_blank" href="http://www.vam.ac.uk/"><img class="logo" src="@/assets/icons/logo-VAM.svg" /></a>
      <transition name="fade">
        <router-link v-if="!detailedView" class="fact-link" to="/facts">
          View all key dates
        </router-link>
      </transition>
      <transition name="fade">
        <div v-if="!detailedView" class="legenda desktop" >
          <div>
            <div class="line"></div>
            <span class="small-text">In construction</span>
          </div>
          <div>
            <div class="line"></div>
            <span class="small-text">Completed</span>
          </div>
        </div>
      </transition>
    </template>
  </div>

</template>

<script>
// @ is an alias to /src
import Splash from '@/components/Splash.vue'

export default {
  name: 'navbar',
  components: {
    Splash
  },
  computed:{
    barStyle() {
      if(this.factsPanelVisible)
      return {
        "top": '-70px'
      };
      return {
        "top": this.topPosition
      };
    },
    detailedView: function(){
      return this.$store.state.detailedView;
    },
    factsPanelVisible: function(){
      return this.$route.path == '/facts';
    },
    isMobile: function(){
      return this.$store.state.isMobile;
    },
    isNavbarVisible: {
      get() { return this.$store.state.isNavbarVisible; },
      set(d) { this.$store.commit('setNavbarVisible', d); },
    },
    resetScroll:{
      get() { return this.$store.state.resetScroll; },
      set(d) { this.$store.commit('setResetScroll', d); },
    },
    infoVisible:{
      get() { return this.$store.state.infoVisible; },
      set(d) { this.$store.commit('setInfoVisible', d); },
    }
  },
  data() {
    return {
      topPosition:'-70px',
      isSplashVisible: true
    }
  },
  mounted: function(){
    window.addEventListener('scroll', ()=> {
      this.isSplashVisible = window.scrollY<window.innerHeight;
      if(this.scrollY!=undefined && !this.resetScroll){
        if(window.scrollY-this.scrollY>50){
          this.scrollY = window.scrollY;
          this.isNavbarVisible = false;
          if(this.isMobile)
          this.topPosition = '-70px';
          else
          this.topPosition = '0px';
        }
        if(window.scrollY-this.scrollY<-50){
          this.topPosition = '0px';
          this.scrollY = window.scrollY;
          this.isNavbarVisible = true;
        }
      } else
      this.scrollY = window.scrollY;
    });
  }
}
</script>
<style  lang="scss">
#navbar{
  position:fixed;
  top:0px;
  left:0px;
  /*width:100vw;*/
  z-index: 11;
  transition: all 0.3s ease 0s;

  font-size:1.14rem;
  padding-left: 1.63rem;
  padding-right: 1.63rem;
  padding-top: 1.04rem;
  font-weight: normal;
  color:#ff6063;
  box-sizing:border-box;
  .logo{
    position: fixed;
    right:1.63rem;
    bottom:1.63rem;
  }
  a.menu-item:hover{
    color:white;
    /**{
    text-decoration: underline !important;
  }*/
}
}



.fact-link{
  padding-left: 1.63rem;
  box-sizing: border-box;
  font-size:1.1rem;
  line-height: 1.1rem;
  color:#ffffff;
  font-weight: lighter;
  position:fixed;

  left: calc(100vw - 502px);
  bottom: 1.63rem;
}

.fact-link:hover{
  color:gray
}

.menu-item{
  display: inline-block;
  margin-bottom:0.3rem;
}

nav{
  position:relative;
  align-items: stretch;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  height:100%;

}
.info{
  position:fixed;
  left:0px;
  top:0px;
  height:100vh;
  width:100vw;
  background:black;
}
.info .scroll-icon{
  display:none;
}
.legenda{
  position:fixed;
  right:2rem;
  bottom:1.63rem;
  display:flex;
  flex-direction: column;
  >div:nth-child(1){
    display:flex;
    div{
      border-bottom: 2px solid rgb(255, 255, 255);
      width:1.5rem;
      transform: translateY(-0.25rem);
    }
    span{
      margin-left:0.5rem;
      color:rgb(255, 255, 255);
    }
  }
  >div:nth-child(2){
    display:flex;
    div{
      border-bottom: 2px solid rgb(255, 96, 99);
      width:1.5rem;
      transform: translateY(-0.25rem);
    }
    span{
      margin-left:0.5rem;
      color:rgb(255, 255, 255);
    }
  }
}

</style>
